import { GearSixIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { Button } from 'app/components/ui/button'

/**
 * A list's Settings, on its title row in every view. It configures the list itself, not the
 * view on screen, so it stays out of the toolbar row with the view switch and the table tools.
 */
export function ListSettingsButton({ onClick }: { onClick: () => void }): ReactElement {
  return (
    <Button variant="white" onClick={onClick}>
      <GearSixIcon size={16} weight="bold" /> Settings
    </Button>
  )
}
